/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32CriteriaRangeResponse
 */
export interface Int32CriteriaRangeResponse {
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof Int32CriteriaRangeResponse
     */
    to?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Int32CriteriaRangeResponse
     */
    exclude?: boolean;
}

export function Int32CriteriaRangeResponseFromJSON(json: any): Int32CriteriaRangeResponse {
    return Int32CriteriaRangeResponseFromJSONTyped(json, false);
}

export function Int32CriteriaRangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32CriteriaRangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function Int32CriteriaRangeResponseToJSON(value?: Int32CriteriaRangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'to': value.to,
        'exclude': value.exclude,
    };
}


